import { Paper, Title, Text, Stack, Group } from "@mantine/core";
import { mobileVendor, mobileModel, osName, osVersion } from "react-device-detect";
import { IconDeviceMobile, IconDeviceDesktop } from "@tabler/icons";
import IconBadge from "../../components/IconBadge";

const DEVICE_COLOR = "#0ca678";

export default function ModuleCurrentDevice() {
  // On desktop, react-device-detect has no specific "model" to report (mobileModel/mobileVendor
  // default to the string "none"), so fall back to just the OS name as the device label there.
  const hasKnownModel = mobileModel && mobileModel !== "none";
  const deviceLabel = hasKnownModel
    ? [mobileVendor !== "none" ? mobileVendor : null, mobileModel].filter(Boolean).join(" ")
    : osName;
  const DeviceIcon = hasKnownModel ? IconDeviceMobile : IconDeviceDesktop;

  return (
    <Paper shadow="sm" radius="md" p="md" withBorder>
      <Group spacing="sm" noWrap align="flex-start">
        <IconBadge color={DEVICE_COLOR} icon={<DeviceIcon size={20} stroke={2.5} color={DEVICE_COLOR} />} />
        <Stack spacing={0} sx={{ minWidth: 0, flex: 1 }}>
          <Text size="xs" fw={700} tt="uppercase" color="dimmed" sx={{ letterSpacing: 0.4 }}>
            Current Device
          </Text>
          {/* No line clamp - a long device/OS name wraps onto a second line instead of being cut
              off, so it's always fully readable regardless of how narrow the card gets. */}
          <Title order={2} weight={800}>
            {deviceLabel}
          </Title>
          <Title order={5} weight={300} color="dimmed">
            Version: {osVersion || "Unknown"}
          </Title>
        </Stack>
      </Group>
    </Paper>
  );
}
